module.exports = __webpack_public_path__ + "img/b_KalciyCS_2.b2aa8834.jpeg";